// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable selector-class-pattern */


.hA6llC3joBBUnEIalIug {
    --color-icon-mono: #4C4C4C;    
    --color-icon-smart-id: #00AFAA;
    --color-icon-mobile-id: #076CE3;
    --color-icon-idcard-primary: #102F5E;
    --color-icon-idcard-secondary:  #F03C1F;

    &.MuiTabs-root {
        overflow: visible !important;
    }

    & .MuiTabs-scroller {
        overflow: visible !important;
    }

    & .MuiTabs-list {
        gap: 1rem;
    }
}

.UHAd8S9Ce282YF6Kaz1D {
    &[role="tab"] {
        flex: 1;
        max-width: initial;
        border-radius: 8px;
        padding: 0.5rem 1.5rem;
        text-transform: none;
        color: var(--color-neutrals-gray-100);
        background-color: var(--color-primary-white);
        white-space: nowrap;
        min-height: 54px;
        outline: 1px solid var(--color-neutrals-gray-300);

        &:focus, &:hover {
            .smartid-monochrome_svg__wrapper {
                fill: var(--color-icon-smart-id);
            }

            .mobileid-monochrome_svg__wrapper {
                fill: var(--color-icon-mobile-id);
            }

            .idcard-monochrome_svg__primary-path {
                fill: var(--color-icon-idcard-primary);
            }
    
            .idcard-monochrome_svg__secondary-path {
                fill: var(--color-icon-idcard-secondary);
            }

            svg[class*="eps-logo_svg__wrapper"] [class*="eps-mono"] {
                display: none;
            }

            svg[class*="eps-logo_svg__wrapper"] [class*="eps-color"] {
                display: block;
            }
        }

        .smartid-monochrome_svg__wrapper,
        .mobileid-monochrome_svg__wrapper, 
        .idcard-monochrome_svg__wrapper {
            display: block;
            fill: var(--color-icon-mono);
        }

        svg[class*="eps-logo_svg__wrapper"] [class*="eps-mono"] {
            display: block;
            fill: var(--color-icon-mono);
            stroke: none;
        }

        svg[class*="eps-logo_svg__wrapper"] [class*="eps-color"] {
            display: none;
        }

        &:active {
            background-color: var(--color-neutrals-gray-400);
        }

        &:focus:not([aria-selected="true"]), &:hover:not([aria-selected="true"]) {
            color: var(--color-primary-black);
            outline: 1px solid var(--color-neutrals-gray-100);
        }
    }
    
    &[aria-selected="true"] {
        color: var(--color-primary-black) !important;
        outline: 2px solid var(--color-neutrals-gray-100);

        .smartid-monochrome_svg__wrapper {
            fill: var(--color-icon-smart-id);
        }        
        
        .mobileid-monochrome_svg__wrapper {
            fill: var(--color-icon-mobile-id);
        }

        .idcard-monochrome_svg__primary-path {
            fill: var(--color-icon-idcard-primary);
        }

        .idcard-monochrome_svg__secondary-path {
            fill: var(--color-icon-idcard-secondary);
        }

        svg[class*="eps-logo_svg__wrapper"] [class*="eps-mono"] {
            display: none;
        }

        svg[class*="eps-logo_svg__wrapper"] [class*="eps-color"] {
            display: block;
        }
    }
}

.gyGmnJBcnGM5EmP5sZZA {
    color: var(--color-primary-black);
    text-decoration: underline;
}

._1T0purCGozRD334t7cc {
    margin-bottom: 0.15rem !important;
}

.Pf0QYkfOeeBI44Eihg4U ._1T0purCGozRD334t7cc {
    margin-top: -1rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/features/auth/components/AuthMainForm/AuthMainForm.module.css"],"names":[],"mappings":"AAAA,6CAA6C;;;AAG7C;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;IAC/B,oCAAoC;IACpC,uCAAuC;;IAEvC;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,OAAO;QACP,kBAAkB;QAClB,kBAAkB;QAClB,sBAAsB;QACtB,oBAAoB;QACpB,qCAAqC;QACrC,4CAA4C;QAC5C,mBAAmB;QACnB,gBAAgB;QAChB,iDAAiD;;QAEjD;YACI;gBACI,gCAAgC;YACpC;;YAEA;gBACI,iCAAiC;YACrC;;YAEA;gBACI,sCAAsC;YAC1C;;YAEA;gBACI,wCAAwC;YAC5C;;YAEA;gBACI,aAAa;YACjB;;YAEA;gBACI,cAAc;YAClB;QACJ;;QAEA;;;YAGI,cAAc;YACd,4BAA4B;QAChC;;QAEA;YACI,cAAc;YACd,4BAA4B;YAC5B,YAAY;QAChB;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,gDAAgD;QACpD;;QAEA;YACI,iCAAiC;YACjC,iDAAiD;QACrD;IACJ;;IAEA;QACI,4CAA4C;QAC5C,iDAAiD;;QAEjD;YACI,gCAAgC;QACpC;;QAEA;YACI,iCAAiC;QACrC;;QAEA;YACI,sCAAsC;QAC1C;;QAEA;YACI,wCAAwC;QAC5C;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,cAAc;QAClB;IACJ;AACJ;;AAEA;IACI,iCAAiC;IACjC,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC","sourcesContent":["/* stylelint-disable selector-class-pattern */\n\n\n.tabs {\n    --color-icon-mono: #4C4C4C;    \n    --color-icon-smart-id: #00AFAA;\n    --color-icon-mobile-id: #076CE3;\n    --color-icon-idcard-primary: #102F5E;\n    --color-icon-idcard-secondary:  #F03C1F;\n\n    &:global(.MuiTabs-root) {\n        overflow: visible !important;\n    }\n\n    & :global(.MuiTabs-scroller) {\n        overflow: visible !important;\n    }\n\n    & :global(.MuiTabs-list) {\n        gap: 1rem;\n    }\n}\n\n.tab {\n    &[role=\"tab\"] {\n        flex: 1;\n        max-width: initial;\n        border-radius: 8px;\n        padding: 0.5rem 1.5rem;\n        text-transform: none;\n        color: var(--color-neutrals-gray-100);\n        background-color: var(--color-primary-white);\n        white-space: nowrap;\n        min-height: 54px;\n        outline: 1px solid var(--color-neutrals-gray-300);\n\n        &:focus, &:hover {\n            :global(.smartid-monochrome_svg__wrapper) {\n                fill: var(--color-icon-smart-id);\n            }\n\n            :global(.mobileid-monochrome_svg__wrapper) {\n                fill: var(--color-icon-mobile-id);\n            }\n\n            :global(.idcard-monochrome_svg__primary-path) {\n                fill: var(--color-icon-idcard-primary);\n            }\n    \n            :global(.idcard-monochrome_svg__secondary-path) {\n                fill: var(--color-icon-idcard-secondary);\n            }\n\n            :global(svg[class*=\"eps-logo_svg__wrapper\"] [class*=\"eps-mono\"]) {\n                display: none;\n            }\n\n            :global(svg[class*=\"eps-logo_svg__wrapper\"] [class*=\"eps-color\"]) {\n                display: block;\n            }\n        }\n\n        :global(.smartid-monochrome_svg__wrapper),\n        :global(.mobileid-monochrome_svg__wrapper), \n        :global(.idcard-monochrome_svg__wrapper) {\n            display: block;\n            fill: var(--color-icon-mono);\n        }\n\n        :global(svg[class*=\"eps-logo_svg__wrapper\"] [class*=\"eps-mono\"]) {\n            display: block;\n            fill: var(--color-icon-mono);\n            stroke: none;\n        }\n\n        :global(svg[class*=\"eps-logo_svg__wrapper\"] [class*=\"eps-color\"]) {\n            display: none;\n        }\n\n        &:active {\n            background-color: var(--color-neutrals-gray-400);\n        }\n\n        &:focus:not([aria-selected=\"true\"]), &:hover:not([aria-selected=\"true\"]) {\n            color: var(--color-primary-black);\n            outline: 1px solid var(--color-neutrals-gray-100);\n        }\n    }\n    \n    &[aria-selected=\"true\"] {\n        color: var(--color-primary-black) !important;\n        outline: 2px solid var(--color-neutrals-gray-100);\n\n        :global(.smartid-monochrome_svg__wrapper) {\n            fill: var(--color-icon-smart-id);\n        }        \n        \n        :global(.mobileid-monochrome_svg__wrapper) {\n            fill: var(--color-icon-mobile-id);\n        }\n\n        :global(.idcard-monochrome_svg__primary-path) {\n            fill: var(--color-icon-idcard-primary);\n        }\n\n        :global(.idcard-monochrome_svg__secondary-path) {\n            fill: var(--color-icon-idcard-secondary);\n        }\n\n        :global(svg[class*=\"eps-logo_svg__wrapper\"] [class*=\"eps-mono\"]) {\n            display: none;\n        }\n\n        :global(svg[class*=\"eps-logo_svg__wrapper\"] [class*=\"eps-color\"]) {\n            display: block;\n        }\n    }\n}\n\n.link {\n    color: var(--color-primary-black);\n    text-decoration: underline;\n}\n\n.tightTop {\n    margin-bottom: 0.15rem !important;\n}\n\n.onlyNotification .tightTop {\n    margin-top: -1rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabs": `hA6llC3joBBUnEIalIug`,
	"tab": `UHAd8S9Ce282YF6Kaz1D`,
	"link": `gyGmnJBcnGM5EmP5sZZA`,
	"tightTop": `_1T0purCGozRD334t7cc`,
	"onlyNotification": `Pf0QYkfOeeBI44Eihg4U`
};
module.exports = ___CSS_LOADER_EXPORT___;
